module.exports = __webpack_public_path__ + "5a54a287d5fa61b89b565b83755ee341.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Kobetz.png
// module id = aT0e
// module chunks = 0